<template>
  <footer v-if="!commentShow">
    <div class="m-footer-layout-bar">
      <div class="m-fixed-b m-footer-bar">
        <input type="text" readonly @click="showComment" value="我来说两句.." class="fz14 m-footer-bar-input">
        <span class="m-footer-share fz14" @click="showShare" v-if="appInfo"><img :src="icons.share"><span>分享</span></span>
      </div>
    </div>
  </footer>
</template>

<script>
import iconShare from '../../assets/icons/share.png'
import hhkjsq from '@/common/hhkjsq.js'
import {inOtherBroswer, isLogin} from '@/utils/index'
const {appInfo} = hhkjsq
export default {
  data () {
    return {
      show: {
        bar: true,
        area: false
      },
      icons: {
        share: iconShare
      },
      appInfo: appInfo
    }
  },

  computed: {
    commentShow () {
      return this.$store.state.comment.show
    }
  },

  methods: {
    showComment () {
      if (inOtherBroswer()) return
      if (isLogin()) {
        this.$store.dispatch('recordScrolltop')
        this.$store.dispatch('showCommentArea')
        this.$store.dispatch('focusbottom')
      }
    },
    showShare () {
      this.$store.dispatch('showShare')
    }
  }
}
</script>



// WEBPACK FOOTER //
// footer.vue?12616cfd